












import { Component, Vue, Ref, Prop } from 'vue-property-decorator';
import DictionaryCard from './DictionaryCard.vue';
import { DictionaryEntry } from '@/dictionary';

@Component({
    components: {
        DictionaryCard
    }
})
export default class DictionaryComponent extends Vue {

    @Prop({ required: true })
    private dictionary!: DictionaryEntry[];

    @Prop({ default: true })
    private displayCategory!: boolean;

}
